import { Box, Typography, Select, MenuItem, Pagination, FormControl } from "@mui/material";
import { GridFooterContainer } from "@mui/x-data-grid";

const pageSizeOptions = [25, 50, 75, 100, 200];

const CustomPaginationFooter = ({
  page,
  pageSize,
  rowCount,
  onPageChange,
  onPageSizeChange,
}) => {
  const totalPages = Math.ceil(rowCount / pageSize);
  const from = rowCount === 0 ? 0 : page * pageSize + 1;
  const to = Math.min((page + 1) * pageSize, rowCount);

  return (
    <GridFooterContainer
      sx={{
        px: 2,
        py: 1,
        justifyContent: "flex-end",
        alignItems: "center",
        display: "flex",
      }}
    >
      {/* Left Side */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Typography variant="body2">Rows per page:</Typography>
        <FormControl size="small">
          <Select
            value={pageSize}
            onChange={(e) => onPageSizeChange(e.target.value)}
            variant="standard"
            disableUnderline
          >
            {pageSizeOptions.map((size) => (
              <MenuItem key={size} value={size}>
                {size}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Typography variant="body2">
          {from}–{to} of {rowCount}
        </Typography>
      </Box>

      {/* Right Side */}
      <Pagination
        count={totalPages}
        page={page + 1}
        onChange={(_, newPage) => onPageChange(newPage - 1)}
        size="small"
        shape="rounded"
        // color="primary"
      />
    </GridFooterContainer>
  );
};

export default CustomPaginationFooter;
